module.exports = __webpack_public_path__ + "firetv.0a5782.svg";